<template>
  <div v-loading="isFetchingCompanies">
    <Selector
      class="analytics-company-selector"
      required
      title="Выберите кампанию"
      isMulti
      hasSearch
      showSelectAll
      style="--options-container-max-height: 40rem"
      :key="'analytics-company-selector' + selectedAccounts.length + selectedCompanies.lenght"
      :disabled="!selectedAccounts.length || selectedAccounts.length > 1"
      limitOptionsHeight
      :options="companiesOptions"
      :value="selectedCompanies"
      :select-fitrst-item="false"
      @onChange="debouncedChangeCompanies"
    />
  </div>
</template>

<script>
import Selector from '@/components/sort/Selector';
import { AnalyticsType } from '@/utils/common';
import { debounce } from '@/utils/helpers';

export default {
  name: 'AnalyticsCompanySelector',
  components: {
    Selector,
  },
  data() {
    return {
      isFetchingCompanies: false,
      companies: [],
      debouncedFetchCompanies: null, // Для хранения debounce-функции
      // debouncedFetchAnalytics: null, // Для хранения debounce-функции
      debouncedChangeCompanies: null, // Для хранения debounce-функции
    };
  },
  created() {
    this.debouncedFetchCompanies = debounce(this.fetchCompanies, 1000);
    // this.debouncedFetchAnalytics = debounce(this.fetchAnalytics, 1000);
    this.debouncedChangeCompanies = debounce(this.handleSelectorChange, 1000);
  },
  computed: {
    previousCompaniesData() {
      return this.$store.state.Analytics[AnalyticsType.ADVANCED].previousCompaniesData || [];
    },
    selectedAccounts() {
      return [...this.$store.state.Analytics[AnalyticsType.ADVANCED].selectedAccounts];
    },
    selectedCompanies() {
      return [...this.$store.state.Analytics[AnalyticsType.ADVANCED].selectedCompanies];
    },
    previousAccountsData() {
      return this.$store.state.Analytics[AnalyticsType.ADVANCED].previousAccountsData || [];
    },
    companiesOptions() {
      return this.companies.map((company) => ({ id: company.id, name: company.name }));
    },
    // companiesOptions() {
    //   if (this.previousCompaniesData) {
    //     // Собираем все аккаунты из всех сервисов
    //     const arr = [];
    //     Object.keys(this.previousCompaniesData).forEach(key => {
    //       arr.push(...this.previousCompaniesData[key]);
    //     });
    //     // Оставляем только уникальные по id (и name, если id нет)
    //     const uniqueMap = new Map();
    //     arr.forEach(item => {
    //       if (item.id && !uniqueMap.has(item.id)) {
    //         uniqueMap.set(item.id, { id: item.id, name: item.name });
    //       }
    //     });
    //     // Добавим аккаунты без id, но с уникальным name
    //     arr.forEach(item => {
    //       if (!item.id && item.name && ![...uniqueMap.values()].find(i => i.name === item.name)) {
    //         uniqueMap.set(`name:${item.name}`, { id: null, name: item.name });
    //       }
    //     });
    //     return Array.from(uniqueMap.values());
    //   } else {
    //     return []
    //   }
    // },
    activeAccount() {
      return this.$store.state.Auth.activeAccount;
    },
  },
  methods: {
    handleSelectorChange(companies) {
      this.$store.commit('Analytics/changeSelectedCompanies', [...companies]);
      this.fetchAnalytics();
    },
    async fetchAnalytics() {
      try {
        this.$store.commit('Analytics/toggleLoading', {
          value: true,
          type: AnalyticsType.ADVANCED,
        });
        await this.$store.dispatch('Analytics/getAdvancedAnalytics', this.activeAccount.id);
      } catch (e) {
        console.error('Failed to fetch analytics:', e);
      } finally {
        this.$store.commit('Analytics/toggleLoading', {
          value: false,
          type: AnalyticsType.ADVANCED,
        });
      }
    },
    async fetchCompanies() {
      if (!this.selectedAccounts.length || this.selectedAccounts.length > 1) {
        this.companies = [];
        return;
      }

      this.isFetchingCompanies = true;

      try {
        const response = await this.$store.dispatch('Ad/getCampaigns', {
          account_id: this.selectedAccounts[0], // Берем первый (и единственный) выбранный аккаунт
        });

        this.companies = response.data.data;
      } catch (e) {
        console.error('Failed to fetch companies,', e);
        this.companies = [];
      } finally {
        this.isFetchingCompanies = false;
      }
    },
  },
  watch: {
    selectedAccounts() {
      this.debouncedFetchCompanies();
    },
  },
};
</script>
